import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useAppConstantsContext } from '@/context/AppConstants';
import { List, Stack, Text } from '@/theme/index';

export const TitleRecordsHowItWorks = () => {
  const {
    data: { brandName },
  } = useAppConstantsContext();

  const isInUnlockTitlesVariation = useFeatureIsOn('bump-3416');

  const infoList = [
    "An automobile's Vehicle Identification Number (VIN).",
    'Any description of the automobile on the certificate of title, including all brand information.',
    'The name of the individual or entity to whom the title certificate was issued (for law enforcement and state motor vehicle agencies ONLY); and Information from junk or salvage yard operators or insurance carriers regarding their acquisition of junk automobiles or salvage automobiles, if this information is being collected by the state.',
  ];

  if (isInUnlockTitlesVariation) {
    infoList.push(
      'Name of the individual or entity from whom the automobile was obtained (this information will be available to law enforcement and appropriate governmental agencies ONLY).'
    );
  }

  return (
    <Stack
      direction="column"
      fontSize="0.9rem"
      spacing={1}
      color={(theme) => theme.palette.grey[800]}
      data-testid="how-it-works-title-records"
    >
      <Text variant="body2" component="span">
        {brandName}’s title data is provided by NMVTIS. Currently, 99% of
        vehicles on the road in the U.S. are represented in the NMVTIS system.,
        including 49 state jurisdictions plus DC. These state agencies have
        separate responsibilities and reporting requirements under the NMVTIS
        rules and regulations than do other reporting entities, such as
        junk/salvage yards and insurance carriers. Verifying the validity of the
        title helps prevent auto fraud and theft. Specifically, states must
        report:
      </Text>
      <List sx={{ listStyleType: 'disc', paddingLeft: 4 }}>
        {infoList.map((info, index) => (
          <Text variant="body2" component="li" key={index}>
            {info}
          </Text>
        ))}
      </List>
      <Text variant="body2" component="span">
        The Anti-Car Theft Act also requires that the NMVTIS operator make
        available the odometer reading that is disclosed pursuant to 49 U.S.C.
        32705 on the date that the certificate of title was issued and any later
        mileage information, if available. States shall provide information on
        new titles and any updated title information to NMVTIS at least once
        every 24 hours.
      </Text>
    </Stack>
  );
};
